import { Divider, useMediaQuery } from '@mui/material';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import dynamic from 'next/dynamic';

const SettingBox = dynamic(() => import('../game-settings'), {
  ssr: false,
});
const GameRecommended = dynamic(
  () => import('@/components/features/common/GameRecommended'),
  {
    ssr: false,
  },
);
import DiceGameInfo from './DiceGameInfo';
const DiceGameBox = dynamic(() => import('./DiceGameBox'), {
  ssr: false,
});
const DiceBetMenu = dynamic(() => import('./DiceBetMenu'), {
  ssr: false,
});

const FeatureDice = styled(Box)(({ theme }) => ({}));
const DiceWrapper = styled(Box)(({ theme }) => ({
  marginBottom: '24px',
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
}));
const DiceContent = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  display: 'flex',
  gap: '20px',
  background: theme.palette.bg.main,
  minHeight: '472px',
  [theme.breakpoints.down('md')]: {
    minHeight: 'auto',
  },
}));

export default function DiceGame() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <FeatureDice>
      <DiceWrapper>
        <DiceContent>
          <DiceBetMenu></DiceBetMenu>
          <DiceGameBox></DiceGameBox>
        </DiceContent>
      </DiceWrapper>

      {!isMobile && (
        <SettingBox
          isMob={isMobile}
          gameId={'crash'}
          fairnessLink={'/casino/fairness'}
        ></SettingBox>
      )}
      <DiceGameInfo />
      <GameRecommended />

      <Divider sx={{ my: 4 }} />
    </FeatureDice>
  );
}
